import * as _ from "lodash";
import { createSlice } from "@reduxjs/toolkit";
import {
  addSession,
  convertTicket,
  countSessionWaiting,
  editSession,
  listSessionHistoryByRequester,
  querySession,
  readSession,
  readSessionByRequesterId,
  removeSession,
  reportChat,
  reportRating,
  reportStaff,
} from "./thunkAction";

const initialState = {
  sessions: [],
  sessionRequester: {},
  session: {},
  sessionHistory: [],
  loading: false,
  error: null,
  skip: 0,
  limit: 10,
  total: 0,
  reportChat: {},
  reportRating: {},
  reportStaff: {},
  totalSessionWaiting: 0,
  isLoadingConvertTicket: false,
  errorConvertTicket: null,
};

const sessionSlice = createSlice({
  name: "sessionManage",
  initialState,
  reducers: {
    clearSession(state) {
      state.sessions = [];
      state.session = {};
      state.skip = 0;
      state.limit = 10;
      state.total = 0;
    },
    clearSessions(state) {
      state.sessions = [];
      state.skip = 0;
      state.limit = 10;
      state.total = 0;
    },
    clearSessionById(state, action) {
      const sessionId = _.get(action, "payload", "");
      state.sessions = state.sessions = _.filter(
        state.sessions,
        (session) => session._id !== sessionId
      );
    },
    clearReportChat(state) {
      state.reportChat = {};
    },
    clearReportRating(state) {
      state.reportRating = {};
    },
    resetProfileError(state) {
      state.error = null;
    },
    setLimit(state, action) {
      state.limit = _.get(action, "payload", 10);
    },
    setSkip(state, action) {
      state.skip = _.get(action, "payload", 0);
    },
  },
  extraReducers: (builder) => {
    builder
      // querySession
      .addCase(querySession.pending, (state) => {
        state.loading = true;
      })
      .addCase(querySession.fulfilled, (state, action) => {
        state.error = null;
        state.loading = false;
        const data = _.get(action, "payload", {});
        const sessions = _.get(data, "data", []);
        const mergedSessions = [...sessions, ...state.sessions];
        const uniqueSession = _.uniqBy(mergedSessions, "_id");
        state.sessions = _.sortBy(uniqueSession, "updateTime").reverse();
        state.total = _.get(data, "metadata.total", 0);
      })
      .addCase(querySession.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // addSession
      .addCase(addSession.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addSession.fulfilled, (state, action) => {
        state.loading = false;
        state.session = _.get(action, "payload", {});
      })
      .addCase(addSession.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // editSession
      .addCase(editSession.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(editSession.fulfilled, (state, action) => {
        state.loading = false;
        const session = _.get(action, "payload", {});
        state.session = session;
      })
      .addCase(editSession.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // removeSession
      .addCase(removeSession.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(removeSession.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(removeSession.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // countSessionWaiting
      .addCase(countSessionWaiting.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(countSessionWaiting.fulfilled, (state, action) => {
        state.loading = false;
        const total = _.get(action, "payload", 0);
        state.totalSessionWaiting = total;
      })
      .addCase(countSessionWaiting.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // readSession
      .addCase(readSession.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(readSession.fulfilled, (state, action) => {
        state.loading = false;
        const session = _.get(action, "payload", {});
        state.session = session;
      })
      .addCase(readSession.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // readSessionByRequesterId
      .addCase(readSessionByRequesterId.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(readSessionByRequesterId.fulfilled, (state, action) => {
        state.loading = false;
        const session = _.get(action, "payload", {});
        const requesterId = _.get(session, "requesterId");
        if (requesterId) {
          state.sessionRequester[requesterId] = session;
        }
      })
      .addCase(readSessionByRequesterId.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // convertTicket
      .addCase(convertTicket.pending, (state) => {
        state.isLoadingConvertTicket = true;
        state.errorConvertTicket = null;
      })
      .addCase(convertTicket.fulfilled, (state, action) => {
        state.isLoadingConvertTicket = false;
      })
      .addCase(convertTicket.rejected, (state, action) => {
        state.isLoadingConvertTicket = false;
        state.errorConvertTicket = action.payload;
      })
      //listSessionHistoryByRequester
      .addCase(listSessionHistoryByRequester.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(listSessionHistoryByRequester.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        state.sessionHistory = _.get(action, "payload", []);
      })
      .addCase(listSessionHistoryByRequester.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      //reportChat
      .addCase(reportChat.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(reportChat.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        state.reportChat = _.get(action, "payload", {});
      })
      .addCase(reportChat.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      //reportRating
      .addCase(reportRating.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(reportRating.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        state.reportRating = _.get(action, "payload", {});
      })
      .addCase(reportRating.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      //reportStaff
      .addCase(reportStaff.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(reportStaff.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        state.reportStaff = _.get(action, "payload", {});
      })
      .addCase(reportStaff.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const sessionReducer = sessionSlice.reducer;

export const SessionAction = sessionSlice.actions;
